import IPerson from "../../models/people/IPerson";
import IFilter from "./IFilter";

export const FilterPeople = (people: IPerson[], filter: IFilter) => {
    return people.filter(person => {
        const searchText = filter.searchText?.toLowerCase(),
            searchPosition = filter.position?.toLowerCase(),
            searchTeam = filter.team?.toLowerCase(),
            searchCountry = filter.country?.toLowerCase(),
            searchRegion = filter.region?.toLowerCase();

        const personName = person.name.toLowerCase(),
            personPosition = person.position?.toLowerCase(),
            personTeam = person.team?.toLowerCase(),
            personCountry = person.country?.toLowerCase(),
            personRegion = person.region?.toLowerCase();

        const matchesSearchText = !searchText ||
            personName.includes(searchText) ||
            personPosition?.includes(searchText) ||
            personTeam?.includes(searchText) ||
            personCountry?.includes(searchText) ||
            personRegion?.includes(searchText);

        const matchesJobTitle = !searchPosition || personPosition === searchPosition;
        const matchesTeam = !searchTeam || personTeam === searchTeam;
        const matchesCountry = !searchCountry || personCountry === searchCountry;
        const matchesRegion = !searchRegion || personRegion === searchRegion;

        return matchesSearchText && matchesJobTitle && matchesTeam && matchesCountry && matchesRegion;
    });
};